import invariant from 'invariant';
import PropTypes from 'prop-types';
import assoc from "ramda/es/assoc";
import React, { Component } from 'react';
class AbstractSwitch extends Component {
    state = {};
    static getDerivedStateFromProps(props, state) {
        const hasCheckedProp = props.hasOwnProperty('checked');
        const hasDefaultCheckedProp = props.hasOwnProperty('defaultChecked');
        const switched = props.checked || props.defaultChecked || false;
        if (hasCheckedProp && hasDefaultCheckedProp && switched !== state.switched) {
            return assoc('switched', switched, state);
        } else {
            return {};
        }
    }
    componentDidMount() {
        const inputNode = this.checkbox;
        const { switched, onParentShouldUpdate } = this.props;
        if ((!switched || inputNode.checked !== switched) && onParentShouldUpdate) {
            onParentShouldUpdate(inputNode.checked);
        }
    }
    componentDidUpdate() {
        const switched = this.props.checked || this.props.defaultChecked || false;
        if (this.props.onParentShouldUpdate && switched !== this.props.switched) {
            this.props.onParentShouldUpdate(switched);
        }
    }
    isSwitched() {
        return this.checkbox.checked;
    }
    // no callback here because there is no event
    setSwitched(newSwitchedValue) {
        if (!this.props.hasOwnProperty('checked') || this.props.checked === false) {
            this.props.onParentShouldUpdate?.(newSwitchedValue);
            this.checkbox.checked = newSwitchedValue;
        } else {
            invariant(false, 'Cannot call set method while checked is defined as a property.');
        }
    }
    getValue() {
        return this.checkbox.value;
    }
    _handleChange = (event)=>{
        const isInputChecked = this.checkbox.checked;
        const { onParentShouldUpdate, onSwitch } = this.props;
        if (!this.props.hasOwnProperty('checked') && onParentShouldUpdate) {
            onParentShouldUpdate(isInputChecked);
        }
        onSwitch?.(event, isInputChecked);
    };
    render() {
        const { switched, className, inputType, name, disabled, value, onSwitch, onParentShouldUpdate, onCheck, floatingLabelText, ...other } = this.props;
        return /*#__PURE__*/ React.createElement("input", {
            ...other,
            ref: (element)=>{
                this.checkbox = element;
            },
            className: className,
            type: inputType,
            checked: switched,
            onChange: this._handleChange,
            disabled: disabled,
            name: name,
            value: value
        });
    }
}
AbstractSwitch.displayName = 'AbstractSwitch';
AbstractSwitch.propTypes = {
    checked: PropTypes.bool,
    className: PropTypes.string,
    defaultChecked: PropTypes.any,
    disabled: PropTypes.bool,
    inputType: PropTypes.string,
    name: PropTypes.string,
    onCheck: PropTypes.any,
    onParentShouldUpdate: PropTypes.func,
    onSwitch: PropTypes.func,
    switched: PropTypes.bool,
    value: PropTypes.any
};
export default AbstractSwitch;
